import "./Heading.css";

const Heading = () => {
  return <h1 className="header__heading">Przelicznik Walut</h1>;
};
export default Heading;